import { CHANGE_LANG } from "../actions/lang";

export default (state = "en", { type, payload }) => {
	if (type === CHANGE_LANG) {
		return payload;
	} else {
		return state;
	}
};
